/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AirtimeProviderCsvCompareEntryDto { 
    comId: string;
    calculatedCost: number;
    providerCost?: number;
    status: AirtimeProviderCsvCompareEntryDto.StatusEnum;
}
export namespace AirtimeProviderCsvCompareEntryDto {
    export const StatusEnum = {
        Mismatch: 'MISMATCH',
        OnlyCalculated: 'ONLY_CALCULATED',
        OnlyProvider: 'ONLY_PROVIDER'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


export type StatusEnum = typeof AirtimeProviderCsvCompareEntryDto.StatusEnum[keyof typeof AirtimeProviderCsvCompareEntryDto.StatusEnum];
